import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const modules = [{
  title: 'Dance Foundations™',
  description: 'Maîtrisez les bases essentielles : principes pédagogiques, techniques fondamentales, échauffements, posture, musicalité et coordination pour construire des bases solides.'
}, {
  title: 'Movement Library™',
  description: 'Une bibliothèque complète de mouvements, exercices et progressions techniques permettant de développer progressivement les compétences de vos élèves.'
}, {
  title: 'Class Builder System™',
  description: "Des modèles professionnels de planification et des structures de cours prêtes à l'emploi pour créer rapidement des séances organisées en quelques minutes."
}, {
  title: 'Ready-to-Use Dance Classes™',
  description: 'Une vaste collection de cours complets déjà préparés pour les niveaux débutant, intermédiaire et avancé, facilement adaptables selon votre style.'
}, {
  title: 'Program Planning System™',
  description: 'Tous les outils pour organiser votre année : progression pédagogique, planification mensuelle, objectifs et préparation des spectacles.'
}, {
  title: 'Dance Teacher Toolkit™',
  description: 'Une boîte à outils professionnelle : fiches pédagogiques, évaluations, feuilles de suivi, listes de compétences et documents imprimables.'
}];
export function TomiSection() {
  return <section className="py-8 px-4 sm:px-6 bg-white border-y-4 border-brand-cream" data-id="element-163">
      <div className="text-center mb-6" data-id="element-164">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-title mb-2 uppercase leading-tight" data-id="element-165">
          LA SOLUTION QUE VOUS ATTENDIEZ
        </h2>
        <p className="text-base font-subheading font-bold text-brand-rose mb-3 uppercase tracking-wide" data-id="element-166">
          UN SYSTÈME COMPLET DE PLANIFICATION 6-EN-1
        </p>
        <div className="inline-block bg-brand-rose text-white px-4 py-1.5 rounded-md mb-4 shadow-sm" data-id="element-167">
          <p className="font-button font-bold text-sm tracking-wide" data-id="element-168">
            💃 DANCE PRO™ — Le Système Complet
          </p>
        </div>
        <p className="text-sm sm:text-base text-brand-text font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-169">
          DANCE PRO™ est bien plus qu'une simple collection d'exercices. C'est
          un système professionnel conçu pour aider les professeurs de danse à
          préparer leurs cours plus rapidement, construire des progressions
          efficaces et enseigner avec davantage de confiance.
        </p>
      </div>

      <div className="flex flex-col gap-3" data-id="element-170">
        {modules.map((module, i) => <div key={i} className="bg-brand-ivory border border-brand-cream p-4 rounded-lg flex gap-3 items-start shadow-sm hover:shadow-md transition-shadow" data-id="element-171">
            <div className="text-brand-gold shrink-0 mt-0.5" data-id="element-172">
              <CheckCircle2 className="w-6 h-6" data-id="element-173" />
            </div>
            <div data-id="element-174">
              <h3 className="text-base font-bold text-brand-title leading-tight mb-1" data-id="element-175">
                {module.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-relaxed" data-id="element-176">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}